var getDirectionFromAlignmentAndTextDirection=function(textAlignment,textDirection){return"right"===textAlignment?"rtl":"left"===textAlignment?"ltr":textDirection&&"rtl"===textDirection?textDirection:"ltr"};export{getDirectionFromAlignmentAndTextDirection};
//# sourceMappingURL=textDirection.js.map
